import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';
import { ICSSProps } from './maskInput.models';

export const ErrorMessage = styled.p`
  position: relative;
  animation: fadein 2s;
  margin-block: 0;
  margin-inline: 0;
  margin-bottom: -2px !important;
  color: ${theme.colors.text.error};
  font-size: ${theme.typography.fontSize.caption};
  line-height: ${theme.typography.lineHeight.display1};
  font-family: ${theme.typography.fontFamily.primary};
  text-align: left;

  @keyframes fadein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  ${media.desktop`
    margin-bottom: -${theme.spacing.sm} !important;
  `}
`;

export const FieldsetWrap = styled.div`
  height: 60px;
`;

export const Fieldset = styled.div<ICSSProps>`
  position: relative;
  margin: 0;
  padding: 18px 16px 18px 20px;
  height: 60px;
  display: flex;
  ${(props) => {
    if (props.error) {
      return `border: ${theme.borderWidth.thin} solid ${theme.colors.border.error}`;
    }
    return props.isDisabled
      ? `border: ${theme.borderWidth.thin} solid #999`
      : `border: ${theme.borderWidth.thin} solid ${theme.colors.border.default}`;
  }};
  transition: border 2s;
  border-radius: 5px;
  background: transparent;

  .wrapper {
    display: inline-flex;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .wrapper-icon {
    display: flex;
    align-self: center;
  }

  .icon {
    margin: auto;
    display: flex;
    flex-direction: column;
    appearance: none;
    background: none;
    border: none;
    font-family: inherit;
    font-size: inherit;
    padding: 0;

    &:hover {
      cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    }
  }

  ${(props) => (props.isDisabled ? '&:hover {cursor: not-allowed}' : '')}
`;

export const Field = styled.div<ICSSProps>`
  height: 22px;

  dateInput {
    width: 100%;
  }

  input {
    background-color: transparent;
    margin: auto;
    padding: 0;
    width: 100%;
    outline: 0;
    border: 0;
    font-size: ${theme.typography.fontSize.body1};
    font-family: ${theme.typography.fontFamily.primary};
    text-align: left;

    &:disabled {
      background-color: transparent;
      cursor: not-allowed;
    }

    &:focus {
      outline: none;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      box-shadow: 0 0 0 30px white inset !important;
    }
  }
`;

export const Legend = styled.label<ICSSProps>`
  color: ${theme.colors.text.secondary};
  padding: 0 ${theme.spacing.sm};
  margin-left: -5.008px;
  background: white;
  z-index: -2;
  font-size: ${theme.typography.fontSize.body1};
  font-family: ${theme.typography.fontFamily.primary};
  text-align: left;
  position: absolute;
  transition: 0.2s;
  ${(props) =>
    props.raiseLabel
      ? `
        top: -10px;
        font-size: ${theme.typography.fontSize.body3};
        line-height: ${theme.typography.lineHeight.h6};
        z-index:2;
        color: ${theme.colors.text.primary};
      `
      : ``};
`;

export const StorybookWrapper = styled.div`
  width: 300px;
`;

